var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableActionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 29,
    rx: 8,
    fill: "#128B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 19.0312C14.7656 19.3918 14.6323 19.7375 14.3949 19.9925C14.1576 20.2474 13.8357 20.3906 13.5 20.3906C13.1643 20.3906 12.8424 20.2474 12.6051 19.9925C12.3677 19.7375 12.2344 19.3918 12.2344 19.0312C12.2344 18.6707 12.3677 18.325 12.6051 18.07C12.8424 17.8151 13.1643 17.6719 13.5 17.6719C13.8357 17.6719 14.1576 17.8151 14.3949 18.07C14.6323 18.325 14.7656 18.6707 14.7656 19.0312ZM14.7656 14.5C14.7656 14.8605 14.6323 15.2063 14.3949 15.4612C14.1576 15.7162 13.8357 15.8594 13.5 15.8594C13.1643 15.8594 12.8424 15.7162 12.6051 15.4612C12.3677 15.2063 12.2344 14.8605 12.2344 14.5C12.2344 14.1395 12.3677 13.7937 12.6051 13.5388C12.8424 13.2838 13.1643 13.1406 13.5 13.1406C13.8357 13.1406 14.1576 13.2838 14.3949 13.5388C14.6323 13.7937 14.7656 14.1395 14.7656 14.5ZM14.7656 9.96875C14.7656 10.3293 14.6323 10.675 14.3949 10.93C14.1576 11.1849 13.8357 11.3281 13.5 11.3281C13.1643 11.3281 12.8424 11.1849 12.6051 10.93C12.3677 10.675 12.2344 10.3293 12.2344 9.96875C12.2344 9.60822 12.3677 9.26246 12.6051 9.00753C12.8424 8.75259 13.1643 8.60938 13.5 8.60938C13.8357 8.60938 14.1576 8.75259 14.3949 9.00753C14.6323 9.26246 14.7656 9.60822 14.7656 9.96875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActionButton);
export default __webpack_public_path__ + "static/media/table-action-button.6df89da457d31470f6b2510f9a8c06cf.svg";
export { ForwardRef as ReactComponent };